import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

dayjs.extend(utc);

const useCheckTokenExpiry = (exp) => {
  const [isAccessTokenExpired, setIsAccessTokenExpired] = useState(false);

  useEffect(() => {
    const currentTime = dayjs.utc();
    const expTime = dayjs.utc(exp);

    if (currentTime.isAfter(expTime)) {
      setIsAccessTokenExpired(true);
    }
  }, [exp]);

  return isAccessTokenExpired;
};

export default useCheckTokenExpiry;
